<template>
  <a ref="CopyLink">
    <img @click="copyToClipboard()" :src="appUrl + '/img/icons/copy.svg'" class="icon copy" :style="'width: ' + iconWidth + 'rem'" :alt="$t('Set.Social.copy')" :title="$t('Set.Social.copy')"/>
    <label></label>
  </a>
</template>

<script>
  import Config from "@/vuex/Config";

  export default {
    name: 'CopyIcon',
    props: [
      'textToCopy',
      'iconWidth',
      'feedback'
    ],
    data() {
      return {
        appUrl: Config.getters.getAppUrl,
      }
    },
    methods: {
      copyToClipboard: function () {
        navigator.clipboard.writeText(this.textToCopy).then(() => {
          if (this.feedback === 'text') {
            let label = this.$refs['CopyLink'].getElementsByTagName('label')[0];
            label.innerHTML = label.innerHTML + '<span>OK</span>';

            window.setTimeout(function () {
              label.getElementsByTagName('span')[0].remove();
            }, 2000);
          } else if (this.feedback === 'icon') {
            let imgNode = this.$refs['CopyLink'].getElementsByTagName('img')[0];
            imgNode.src = imgNode.src.replace("copy.svg", "copy-active.svg");

            window.setTimeout(function () {
              imgNode.src = imgNode.src.replace("copy-active.svg", "copy.svg");
            }, 2000);
          }
        }).catch((err) => {
          console.log(err)
          console.log('Oops, unable to copy');
        });
        return false;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    .icon.copy {
      display: inline-block;
      margin: -0.25rem 0 0 0;
    }

    label {
      margin: 0;
      padding: 0;
    }
  }
</style>
